import React, { useState, useRef, useMemo } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { logo, signature } from "../../../assets/img";

const GeneratePayslip = () => {

    const payslipRef = useRef(null);

    const [formData, setFormData] = useState({
        employeeName: "",
        employeeId: "",
        department: "",
        designation: "",
        location: "",
        month: "",
        doj: "",
        uan: "",
        pfno: "",
        bankName: "",
        accountNo: "",
        pan: "",

        monthlySalary: 0,

        daysmonth: 30,
        lop: 0,

        bonus: 0,
        otherIncome: 0,

        loan: 0,
        otherDeduction: 0,

        vpf: 0,
        esi: 0,
        kcc: 0,
        cabDeduction: 0,
        yearlySalary: 0,
    });

    /* ================= HANDLE INPUT ================= */

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        const val = type === "number" ? Number(value) : value;

        if (name === "yearlySalary") {
            setFormData((prev) => ({
                ...prev,
                yearlySalary: val,
                monthlySalary: val ? Math.round(val / 12) : 0, // ✅ AUTO CALC
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: val,
            }));
        }
    };

    /* ================= DAYS PAYABLE ================= */

    const dayspayable = useMemo(() => {
        return formData.daysmonth - formData.lop;
    }, [formData.daysmonth, formData.lop]);

    /* ================= SALARY STRUCTURE ================= */

    const basic = formData.monthlySalary * 0.40;
    const hra = basic * 0.50;
    const conveyance = 800;
    const cca = basic * 0.13;
    const medical = 1250;

    const specialAllowance =
        formData.monthlySalary -
        (basic + hra + conveyance + cca + medical);

    /* ================= LOP RATIO ================= */

    const ratio = formData.daysmonth
        ? dayspayable / formData.daysmonth
        : 0;

    /* ================= CURRENT SALARY ================= */

    const currentBasic = basic * ratio;
    const currentHra = hra * ratio;
    const currentConveyance = conveyance * ratio;
    const currentCca = cca * ratio;
    const currentMedical = medical * ratio;
    const currentSpecialAllowance = specialAllowance * ratio;

    /* ================= GROSS SALARY ================= */

    const actualGrossSalary =
        basic +
        hra +
        conveyance +
        cca +
        medical +
        specialAllowance +
        Number(formData.bonus || 0) +
        Number(formData.otherIncome || 0);

    const currentGrossSalary = useMemo(() => {
        return (
            currentBasic +
            currentHra +
            currentConveyance +
            currentCca +
            currentMedical +
            currentSpecialAllowance +
            Number(formData.bonus || 0) +
            Number(formData.otherIncome || 0)
        );
    }, [
        currentBasic,
        currentHra,
        currentConveyance,
        currentCca,
        currentMedical,
        currentSpecialAllowance,
        formData.bonus,
        formData.otherIncome
    ]);

    /* ================= DEDUCTIONS ================= */

    const pf = 1800;
    const professionalTax = 208;

    const totalDeductions = useMemo(() => {
        return (
            pf +
            professionalTax +
            Number(formData.vpf || 0) +
            Number(formData.esi || 0) +
            Number(formData.kcc || 0) +
            Number(formData.cabDeduction || 0) +
            Number(formData.loan || 0) +
            Number(formData.otherDeduction || 0)
        );
    }, [
        formData.vpf,
        formData.esi,
        formData.kcc,
        formData.cabDeduction,
        formData.loan,
        formData.otherDeduction
    ]);

    /* ================= NET SALARY ================= */

    const netSalary = currentGrossSalary - totalDeductions;

    /* ================= PDF DOWNLOAD ================= */

    const downloadPDF = async () => {
        const canvas = await html2canvas(payslipRef.current, { scale: 2 });

        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("l", "mm", "a4"); // 👈 landscape

        const imgWidth = 297; // full landscape width
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

        pdf.save(`${formData.employeeName || "Payslip"}.pdf`);
    };

    return (
        <div className="payslip-container">
            <h2>Complete Payroll Generator</h2>
            <div className="payslip-form ">


                <input name="employeeName" placeholder="Employee Name" onChange={handleChange} />
                <input name="employeeId" placeholder="Employee ID" onChange={handleChange} />
                <input name="designation" placeholder="Designation" onChange={handleChange} />
                <input name="department" placeholder="Department" onChange={handleChange} />
                <input name="location" placeholder="Location" onChange={handleChange} />

                <input name="month" placeholder="Month" onChange={handleChange} />
                <input name="doj" placeholder="Date of Joining" onChange={handleChange} />
                <input name="uan" placeholder="UAN Number" onChange={handleChange} />
                <input name="pfno" placeholder="PF Number" onChange={handleChange} />

                <input name="bankName" placeholder="Bank Name" onChange={handleChange} />
                <input name="accountNo" placeholder="Account Number" onChange={handleChange} />
                <input name="pan" placeholder="PAN Number" onChange={handleChange} />

                <input
                    type="number"
                    name="monthlySalary"
                    placeholder="Monthly Salary"
                    onChange={handleChange}
                />

                <input
                    type="number"
                    name="daysmonth"
                    placeholder="Days In Month"
                    onChange={handleChange}
                />

                <input
                    type="number"
                    name="lop"
                    placeholder="LOP"
                    onChange={handleChange}
                />



                {/* <input
                    type="number"
                    name="otherIncome"
                    placeholder="Other Income"
                    onChange={handleChange}
                /> */}

                {/* <input
                    type="number"
                    name="incomeTax"
                    placeholder="Income Tax"
                    onChange={handleChange}
                />

                <input
                    type="number"
                    name="loan"
                    placeholder="Loan Deduction"
                    onChange={handleChange}
                />

                <input
                    type="number"
                    name="otherDeduction"
                    placeholder="Other Deduction"
                    onChange={handleChange}
                />
                <input
                    type="number"
                    name="vpf"
                    placeholder="VPF"
                    onChange={handleChange}
                />

                <input
                    type="number"
                    name="esi"
                    placeholder="ESI"
                    onChange={handleChange}
                />

                <input
                    type="number"
                    name="kcc"
                    placeholder="KCC"
                    onChange={handleChange}
                />

                <input
                    type="number"
                    name="cabDeduction"
                    placeholder="Cab Deduction"
                    onChange={handleChange}
                />
                */}
                <input
                    type="number"
                    name="yearlySalary"
                    placeholder="Yearly Salary (CTC)"
                    onChange={handleChange}
                />

            </div>



            <div className=" exact-design" ref={payslipRef}>
                {/* HEADER */}
                <div className="header-row p-2">
                    <div className="totle_header">
                        <h3 className="f3 fs-20">RedCloud Soft Solutions Private Limited</h3>
                        <p className="f2 fs-14">
                            173,6th Floor, Block B, TECCI Park, OMR, Sholinganallur,
                            Chennai - 600119
                        </p>
                    </div>
                    <img
                        src={logo}
                        alt="logo"
                        className="payslip-logo"
                        crossOrigin="anonymous"
                    />
                </div>

                <div className="payslip-title p-2 fs-22">PAYSLIP</div>

                {/* EMPLOYEE DETAILS TABLE */}
                <table className="details-table">
                    <colgroup>
                        <col style={{ width: "19%" }} />
                        <col style={{ width: "1%" }} />
                        <col style={{ width: "22%" }} />

                          <col style={{ width: "19%" }} />
                        <col style={{ width: "1%" }} />
                        <col style={{ width: "22%" }} />

                             <col style={{ width: "19%" }} />
                        <col style={{ width: "1%" }} />
                        <col style={{ width: "22%" }} />
                    </colgroup>

                    <tbody>
                        <tr>
                            <td className="label f2">EMP NO</td>
                            <td className="f2 td_1">:</td>
                            <td className="f2">{formData.employeeId}</td>

                            <td className="label f2">Month & Year</td>
                            <td className="f2 td_1">:</td>
                            <td className="f2">{formData.month}</td>

                            <td className="label f2">Days In Month</td>
                            <td className="f2 td_1">:</td>
                            <td className="f2">{formData.daysmonth}</td>
                        </tr>

                        <tr>
                            <td className="label f2">NAME</td>
                            <td className="f2 td_1">:</td>
                            <td className="f2">{formData.employeeName}</td>

                            <td className="label f2">D.O.J</td>
                            <td className="f2 td_1">:</td>
                            <td className="f2">{formData.doj}</td>

                            <td className="label f2">LOP</td>
                            <td className="f2 td_1">:</td>
                            <td className="f2">{formData.lop}</td>
                        </tr>

                        <tr>
                            <td className="label f2">DESIGNATION</td>
                            <td className="f2 td_1">:</td>
                            <td className="f2">{formData.designation}</td>

                            <td className="label f2">UAN</td>
                            <td className="f2 td_1">:</td>
                            <td className="f2">{formData.uan}</td>

                            <td className="label f2">Days Payable</td>
                            <td className="f2 td_1">:</td>
                            <td className="f2">{dayspayable}</td>
                        </tr>

                        <tr>
                            <td className="label f2">LOCATION</td>
                            <td className="f2 td_1">:</td>
                            <td className="f2">{formData.location}</td>

                            <td className="label f2">PF NO</td>
                            <td className="f2 td_1">:</td>
                            <td className="f2">{formData.pfno}</td>

                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>

                {/* SALARY TABLE */}
                <table className="salary-table ">
                    <thead>
                        <tr className="black-head">
                            <th colSpan="4" className="f3 fs-18">Earnings (INR)</th>
                            <th colSpan="2" className="f3 fs-18">Deductions (INR)</th>
                        </tr>
                        <tr className="black-head1">
                            <th className="f3 fs-16">Rate of Salary/Wages</th>
                            <th className="f3 fs-16">Actual</th>
                            <th className="f3 fs-16">Current</th>
                            <th className="f3 fs-16">Arrear</th>
                            <th className="f3"></th>
                            <th className="f3"></th>
                        </tr>
                    </thead>

                    <tbody className="table_align">
                        <tr>
                            <td className="f2 fs-14">Basic</td>
                            <td className="f2 fs-14">{basic.toFixed(2)}</td>
                            <td className="f2 fs-14">{currentBasic.toFixed(2)}</td>
                            <td className="f2 fs-14">0</td>
                            <td className="f2 fs-14 text-start">PF</td>
                            <td className="f2 fs-14">{pf}</td>
                        </tr>

                        <tr>
                            <td className="f2 fs-14">House Rent Allowance</td>
                            <td className="f2 fs-14">{hra.toFixed(2)}</td>
                            <td className="f2 fs-14">{currentHra.toFixed(2)}</td>
                            <td className="f2 fs-14">0</td>
                            <td className="f2 fs-14 text-start">VPF</td>
                            <td className="f2 fs-14">{formData.vpf}</td>

                        </tr>

                        <tr>
                            <td className="f2 fs-14">Conveyance Allowance</td>
                            <td className="f2 fs-14">{conveyance}</td>
                            <td className="f2 fs-14">{currentConveyance.toFixed(2)}</td>
                            <td className="f2 fs-14">0</td>
                            <td className="f2 fs-14 text-start">ESI</td>
                            <td className="f2 fs-14">{formData.esi}</td>
                        </tr>

                        <tr>
                            <td className="f2 fs-14">City Compensatory Allowance (CCA)</td>
                            <td className="f2 fs-14">{cca.toFixed(2)}</td>
                            <td className="f2 fs-14">{currentCca.toFixed(2)}</td>
                            <td className="f2 fs-14">0</td>
                            <td className="f2 fs-14 text-start">Professional Tax</td>
                            <td className="f2 fs-14">{professionalTax}</td>
                        </tr>

                        <tr>
                            <td className="f2 fs-14">Special Allowance</td>
                            <td className="f2 fs-14">{specialAllowance.toFixed(2)}</td>
                            <td className="f2 fs-14">{currentSpecialAllowance.toFixed(2)}</td>
                            <td className="f2 fs-14">0</td>
                            <td className="f2 fs-14 text-start">KCC</td>
                            <td className="f2 fs-14">{formData.kcc}</td>
                        </tr>

                        <tr>
                            <td className="f2 fs-14">Medical Allowance</td>
                            <td className="f2 fs-14">{medical}</td>
                            <td className="f2 fs-14">{currentMedical.toFixed(2)}</td>
                            <td className="f2 fs-14">0</td>
                            <td className="f2 fs-14 text-start">Income Tax</td>
                            <td className="f2 fs-14">0</td>
                        </tr>
                        <tr>
                            <td className="f2 fs-14">Car Fuel Reimbursement</td>
                            <td className="f2 fs-14">{formData.medical}</td>
                            <td className="f2 fs-14">{formData.medical}</td>
                            <td className="f2 fs-14">0</td>
                            <td className="f2 fs-14 text-start">Loan Deduction</td>
                            <td className="f2 fs-14">{formData.loan}</td>
                        </tr>
                        <tr>
                            <td className="f2 fs-14">Statutory Bonus</td>
                            <td className="f2 fs-14">{formData.bonus}</td>
                            <td className="f2 fs-14">{formData.bonus}</td>
                            <td className="f2 fs-14">0</td>
                            <td className="f2 fs-14 text-start">Cab Deduction</td>
                            <td className="f2 fs-14">{formData.cabDeduction}</td>
                        </tr>

                        <tr>
                            <td className="f2 fs-14">Incentive</td>
                            <td className="f2 fs-14">{formData.bonus}</td>
                            <td className="f2 fs-14">{formData.bonus}</td>
                            <td className="f2 fs-14">0</td>
                            <td className="f2 fs-14 text-start">Food Deduction</td>
                            <td className="f2 fs-14">{formData.otherDeduction}</td>
                        </tr>


                        <tr>
                            <td className="f2 fs-14">Leave Encashment</td>
                            <td className="f2 fs-14">{formData.bonus}</td>
                            <td className="f2 fs-14">{formData.bonus}</td>
                            <td className="f2 fs-14">0</td>
                            <td className="f2 fs-14 text-start">Insurance</td>
                            <td className="f2 fs-14">{formData.otherDeduction}</td>
                        </tr>


                        <tr>
                            <td className="f2 fs-14">Leave Encashment</td>
                            <td className="f2 fs-14">{formData.bonus}</td>
                            <td className="f2 fs-14">{formData.bonus}</td>
                            <td className="f2 fs-14">0</td>
                            <td className="f2 fs-14 text-start">Labour Welfare Fund</td>
                            <td className="f2 fs-14">{formData.otherDeduction}</td>
                        </tr>

                        <tr>
                            <td className="f2 fs-14">Other Income</td>
                            <td className="f2 fs-14">{formData.otherIncome}</td>
                            <td className="f2 fs-14">{formData.otherIncome}</td>
                            <td className="f2 fs-14">0</td>
                            <td></td>
                            <td></td>
                        </tr>


                        <tr className="bold-row">
                            <td className="f2 fs-16">Gross Salary</td>
                            <td className="f2 fs-16">{actualGrossSalary.toFixed(2)}</td>
                            <td className="f2  fs-16">{currentGrossSalary.toFixed(2)}</td>
                            <td className="f2  fs-16">0</td>
                            <td className="f2  fs-16 text-start">Total Deductions</td>
                            <td className="f2  fs-16">{totalDeductions}</td>
                        </tr>

                        <tr className="bold-row">
                            <td colSpan="4" className="f2  fs-16">Net Payable Amount (in INR)</td>
                            <td colSpan="5" className="f2  fs-16">{netSalary.toFixed(2)}</td>
                        </tr>
                    </tbody>
                </table>

                <div className="footer-line p-2 f2">
                    <span>
                        Credited in {formData.accountNo} SB A/C with {formData.bankName}
                    </span>

                    <div className="signature">
                        <img src={signature} alt="signature" />
                        <p>Authorised Signatory</p>
                    </div>
                </div>
            </div>

            <div style={{ textAlign: "center", marginTop: "20px" }}>
                <button onClick={downloadPDF} className="download-btn">
                    Download Payslip PDF
                </button>
            </div>
        </div>
    );
};

export default GeneratePayslip;


